import React from 'react';
import { Tray } from '../../components/elements';
import { isSurveyTemplateManifestationData } from '../../components/Surveys/isSurveyTemplateManifestationData';
import { isSurveyTemplateUnitData } from '../../components/Surveys/isSurveyTemplateUnitData';
import { ISurveyTemplateElementGroupData } from '../../components/Surveys/ISurveyTemplateElementGroupData';
import { ISurveyTemplateManifestationData } from '../../components/Surveys/ISurveyTemplateManifestationData';
import { ISurveyTemplateUnitData } from '../../components/Surveys/ISurveyTemplateUnitData';
import { SurveyEditNen3140ManifestationResult } from './SurveyEditNen3140ManifestationResult';
import { SurveyEditNen3140UnitResult } from './SurveyEditNen3140UnitResult';

export function SurveyEditNen3140Result(
    props: { surveyId: string; objectId: string; onItemChanged: () => Promise<void> } & (
        | ISurveyTemplateUnitData
        | ISurveyTemplateElementGroupData
        | ISurveyTemplateManifestationData
    ),
) {
    if (isSurveyTemplateUnitData(props)) {
        return <SurveyEditNen3140UnitResult {...props} />;
    } else if (isSurveyTemplateManifestationData(props)) {
        return <SurveyEditNen3140ManifestationResult {...props} />;
    }
    return <Tray>&nbsp;</Tray>;
}
